export const USER_ALERTS_GET_ALERTS = "USER_ALERTS_GET_ALERTS";
export const USER_ALERTS_GET_ALERTS_RESPONSE = "USER_ALERTS_GET_ALERTS_RESPONSE";